export default __webpack_public_path__ + "static/media/winterfell.227f94c5.jpg";